// Disabling as this just needs to exist to appease TS
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const checkIfCardHasBeenAdded = (cardSuffix: string): string => {
  return 'UNKNOWN';
};

export default checkIfCardHasBeenAdded;
